"use client";

import { useState } from "react";
import ErrorHandling from "../layout/ErrorHandling";
import AuthHeader from "./AuthHeader";
import AuthHero from "./AuthHero";
import RegisterForm from "./RegisterForm";

export default function Signup() {
  const [errorMessage, setErrorMessage] = useState<{
    type: "error" | "success" | "";
    messages: string;
  }>({ type: "", messages: "" });

  return (
    <div className="h-screen flex flex-col lg:flex-row bg-[#F8FAFC] ">
      <AuthHero />

      {/* Right Form */}
      <div className="flex-1 flex flex-col relative bg-white">
        <AuthHeader />

        {errorMessage?.messages && (
          <ErrorHandling
            messages={errorMessage.messages}
            type={errorMessage.type}
          />
        )}

        <RegisterForm setErrorMessage={setErrorMessage} />
      </div>
    </div>
  );
}
